var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('google',{attrs:{"clientId":"395276949039-0s9egduqdrgcc2korumqnvi9vircqrta.apps.googleusercontent.com","appId":"395276949039"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }